import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("pm_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("pm_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("pm_user", JSON.stringify(r.data));
      }).catch(() => {});
    }
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("pm_token", r.data.token);
      localStorage.setItem("pm_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const register = async (email, password, name, security_questions) => {
    setLoading(true);
    try {
      const payload = { email, password, name };
      if (security_questions) payload.security_questions = security_questions;
      const r = await api.post("/auth/register", payload);
      localStorage.setItem("pm_token", r.data.token);
      localStorage.setItem("pm_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("pm_token");
    localStorage.removeItem("pm_user");
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
